<template>
  <section class="flex flex-row items-center gap-1">
    <slot />
  </section>
</template>
